<!--
	@component

	Shared layout for a "detail page" (product detail, course detail): heading, gallery
	(mobile carousel + desktop column) and a set of content areas supplied by the caller
	as snippets, so each page can keep its own domain-specific markup.
-->
<script lang="ts">
	import type { Snippet } from "svelte";
	import type { ClassValue } from "svelte/elements";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import Heading from "./common/Heading.svelte";

	const {
		title,
		headingClass = "font-antipol text-8/tighter lg:text-10 font-medium",
		content,
		form,
		availability,
		mobileGallery,
		desktopGallery,
		promo,
		disclosures,
	}: {
		title: string;
		headingClass?: ClassValue;
		/** Description, variant/term picker, price – everything above the form. */
		content: Snippet;
		/** Buy button / registration form, rendered right after `content`. */
		form?: Snippet;
		/** Stock/seats availability indicator and any related info rows. */
		availability?: Snippet;
		mobileGallery?: Snippet;
		desktopGallery?: Snippet;
		promo?: Snippet;
		disclosures?: Snippet;
	} = $props();
	const { breadcrumbs } = getGlobalTemplateProps();
</script>

<div class={["grid grid-cols-12 lg:gap-16 col-span-full mb-10", breadcrumbs.length === 0 && "mt-10 md:mt-14"]}>
	<div class="col-span-full xl:col-span-5 flex flex-col gap-4 lg:gap-6">
		<Heading level={1} text={title} class={headingClass} />
		{@render content()}
		{@render form?.()}
		{@render availability?.()}
		{#if mobileGallery}
			<div class="xl:hidden col-span-full">
				{@render mobileGallery()}
			</div>
		{/if}
		{@render promo?.()}
		{#if disclosures}
			<div>
				{@render disclosures()}
			</div>
		{/if}
	</div>
	{#if desktopGallery}
		<div class="hidden order-first xl:flex flex-col gap-2 col-span-7">
			{@render desktopGallery()}
		</div>
	{/if}
</div>
